<button class="create-ticket-button" mat-raised-button (click)="onCreateTicketButtonClick()">
  <mat-icon class="material-icons-outlined">rate_review</mat-icon>
  Ticket erstellen
</button>
